import { useToastState } from '#states/hooks.js';

/**
 * Returns a `copy(text, toastTitle?)` helper that writes to the clipboard and confirms with a toast.
 * Used by the itinerary detail rows (copy confirmation code, phone number, etc.).
 */
export function useCopy() {
  const toastState = useToastState();

  return (text: string, toastTitle = 'Copied to clipboard') => {
    void navigator.clipboard
      .writeText(text)
      .then(() => toastState.addToast({ title: toastTitle }))
      .catch(() =>
        toastState.addToast({ title: 'Copy failed', description: 'Please try again.', variant: 'destructive' }),
      );
  };
}
